"use client";

import { useState, type FormEvent } from "react";
import { Input, validateEmail } from "@/design-system/Input/Input";
import { Button } from "@/design-system/Button/Button";
import styles from "./Footer.module.css";

/**
 * Newsletter capture. Wired to the backend later (see BACKEND_NEEDS.md);
 * for now it validates and surfaces a confirmation locally.
 */
export function NewsletterForm() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [error, setError] = useState(false);

  function onSubmit(e: FormEvent) {
    e.preventDefault();
    if (!validateEmail(email)) {
      setError(true);
      return;
    }
    setError(false);
    setDone(true);
    // TODO(backend): POST /newsletter/subscribe { email, locale }
  }

  if (done) {
    return (
      <p className={styles.newsletterDone}>Thank you — you&apos;re on the list.</p>
    );
  }

  return (
    <form className={styles.newsletter} onSubmit={onSubmit} noValidate>
      <Input
        type="email"
        placeholder="Email address"
        aria-label="Email address"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        invalid={error}
        hint={error ? "Please enter a valid email." : undefined}
      />
      <Button type="submit" size="md" variant="solid">
        Subscribe
      </Button>
    </form>
  );
}
